/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Vast_Hawk_SlipInputs */

const en_cool_vast_hawk_slip = /** @type {(inputs: Cool_Vast_Hawk_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel import`)
};

const de_cool_vast_hawk_slip = /** @type {(inputs: Cool_Vast_Hawk_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel import" |
*
* @param {Cool_Vast_Hawk_SlipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_vast_hawk_slip = /** @type {((inputs?: Cool_Vast_Hawk_SlipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Vast_Hawk_SlipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_vast_hawk_slip(inputs)
	return de_cool_vast_hawk_slip(inputs)
});